module.exports = __webpack_public_path__ + "static/media/seat.1a2c261a.svg";